<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <span class="text-muted" style="font-size: 14px">Create By：</span>
        <span class="text-muted" style="font-size: 14px"
          >{{ formData.scoreByName }} at {{ formData.scoreTime }}
        </span>
      </div>
      <div>
        <span class="text-muted" style="font-size: 14px">总分：</span>
        <span style="font-size: 14px">{{ formData.totalTopScore }}</span>
        <el-divider direction="vertical"></el-divider>
        <span class="text-muted" style="font-size: 14px">得分：</span>
        <span style="font-size: 14px">{{ formData.totalScmScore }}</span>
      </div>
    </div>
    <vxe-grid
      class="mt-2"
      border
      round
      resizable
      :tree-config="treeConfig"
      :columns="tableColumn"
      :data="formData.scoreData"
      :loading="loading"
      height="350"
    ></vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    visitScoreCode: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        scoreTime: '',
        scoreByName: '',
        totalTopScore: '',
        totalScmScore: '',
        scoreData: []
      },
      treeConfig: {
        children: 'listItem',
        expandAll: false
      },
      tableColumn: [
        { type: 'seq', width: 50 },
        {
          field: 'itemName',
          title: '评价项目',
          width: 280,
          treeNode: true
        },
        { field: 'itemValue', title: '数值结果', minWidth: 250 },
        {
          field: 'topScore',
          title: '满分值',
          width: 80,
          align: 'center'
        },
        {
          field: 'scmScore',
          title: '实际得分',
          width: 80,
          align: 'center'
        }
      ]
    }
  },
  watch: {
    visitScoreCode: {
      handler() {
        this.loadData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    loadData() {
      let params = {
        visitScoreCode: this.visitScoreCode
      }
      this.reset()
      this.loading = true
      this.$api
        .opaScmVisitscoreGetVisitScoreApi(params)
        .then((res) => {
          this.loading = false
          if (res.body) {
            this.formData = res.body
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    reset() {
      this.formData = {
        scoreTime: '',
        scoreByName: '',
        totalTopScore: '',
        totalScmScore: '',
        scoreData: []
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
